/* eslint-disable no-param-reassign */
const setAdaptiveTextArea = el => {
  el.style.height = `${0}px`
  el.style.height = `${el.scrollHeight}px`
}

export default setAdaptiveTextArea
